import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Profile } from '@common/models/profile.model';
import { StoreDataService } from '@common/services/store-data.service';
import { BaseComponent } from '@components/base-component';
import { URL_CONFIG } from '@constants/locations.constants';

@Component({
    selector: 'app-booking-completed',
    templateUrl: './booking-completed.component.html',
    standalone: false
})
export class BookingCompletedComponent extends BaseComponent implements OnInit, OnDestroy {
    override progressBarStatus = {
        progress: 0,
        completedStep: 0,
        isProgressBarShown: false,
    };
    localSiteUrl!: string;
    override disableNavigation = true;

    constructor(private storeDataService: StoreDataService, private renderer: Renderer2) {
        super();
    }

    override ngOnInit(): void {
        super.ngOnInit();
        const profileSubscription = this.storeDataService
            .profileObserver()
            .subscribe((profile: Profile) => {
                this.localSiteUrl = profile?.localSiteUrl
                    ? profile?.localSiteUrl
                    : URL_CONFIG['US'].LOCAL_SITE;
            });
        this.renderer.addClass(document.body, 'special-page');
        this.addSubscription(profileSubscription);
        this.navigationService.setNextNavigationShown(false);
        this.navigationService.setPrevNavigationShown(false);
        this.progressBarService.changeProgressBarStatus(this.progressBarStatus);
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
        this.renderer.removeClass(document.body, 'special-page');
    }
}
